/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body Mass Index is your weight in kilograms divided by the square of your height in metres. It's a simple screening tool for weight categories.`)
};

const es_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Índice de Masa Corporal es tu peso en kilogramos dividido por el cuadrado de tu altura en metros. Es una herramienta de evaluación simple para categorías de peso.`)
};

const de_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body-Mass-Index ist Ihr Gewicht in Kilogramm geteilt durch das Quadrat Ihrer Größe in Metern. Es ist ein einfaches Screening-Werkzeug für Gewichtskategorien.`)
};

const nl_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body Mass Index is uw gewicht in kilogrammen gedeeld door het kwadraat van uw lengte in meters. Het is een eenvoudig screeninginstrument voor gewichtscategorieën.`)
};

const fr_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'indice de masse corporelle est votre poids en kilogrammes divisé par le carré de votre taille en mètres. C'est un simple outil de dépistage pour les catégories de poids.`)
};

const it_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Indice di Massa Corporea è il tuo peso in chilogrammi diviso per il quadrato della tua altezza in metri. È uno strumento di screening semplice per le categorie di peso.`)
};

const pt_br2_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice de Massa Corporal é seu peso em quilogramas dividido pelo quadrado de sua altura em metros. É uma ferramenta de triagem simples para categorias de peso.`)
};

const pt_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice de Massa Corporal é o seu peso em quilogramas dividido pelo quadrado da sua altura em metros. É uma ferramenta de triagem simples para categorias de peso.`)
};

const ja_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体格指数はキログラムの体重をメートル単位の身長の二乗で割ったものです。これは体重カテゴリのシンプルなスクリーニングツールです。`)
};

const zh_bmi_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身体质量指数是体重（千克）除以身高（米）的平方。它是一种用于体重分类的简单筛查工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq1_a", locale)
	if (locale === "en") return en_bmi_hub_faq1_a(inputs)
	if (locale === "es") return es_bmi_hub_faq1_a(inputs)
	if (locale === "de") return de_bmi_hub_faq1_a(inputs)
	if (locale === "nl") return nl_bmi_hub_faq1_a(inputs)
	if (locale === "fr") return fr_bmi_hub_faq1_a(inputs)
	if (locale === "it") return it_bmi_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq1_a(inputs)
	if (locale === "pt") return pt_bmi_hub_faq1_a(inputs)
	if (locale === "ja") return ja_bmi_hub_faq1_a(inputs)
	return zh_bmi_hub_faq1_a(inputs)
};